import type { $Fetch } from 'ofetch';
import { BaseClient } from '@shared/clients/BaseClient.ts';
import type {
    EvergladesProductsApiHeaders,
    EvergladesProductsApiQueryParams,
    EvergladesProductsApiSuccess,
    Logger,
} from '@shared/types/types';
import type { AsyncResult, Result } from '@shared/types/utilities';

const DEFAULT_TIMEOUT_MS = 1800;

export class EvergladesClient extends BaseClient {
    constructor({
        baseURL,
        fetchClient,
        logger,
        timeout = DEFAULT_TIMEOUT_MS,
    }: {
        fetchClient: $Fetch;
        logger: Logger;
        baseURL?: string;
        timeout?: number;
    }) {
        super(baseURL, fetchClient, logger, timeout);
    }

    async getProducts(
        query: EvergladesProductsApiQueryParams,
        headers?: EvergladesProductsApiHeaders,
    ): AsyncResult<EvergladesProductsApiSuccess> {
        try {
            const payload = await this.fetch<EvergladesProductsApiSuccess>('/everglades/products', {
                query,
                headers: {
                    ...(headers ?? {}),
                    accept: 'application/json',
                },
            });

            return { state: 'success', payload } satisfies Result<EvergladesProductsApiSuccess>;
        } catch (_err: unknown) {
            return {
                state: 'error',
            } satisfies Result<EvergladesProductsApiSuccess>;
        }
    }
}
